// extracted by mini-css-extract-plugin
export default {"card":"card__1e6b5322","row":"row__1e6b5322","price":"price__1e6b5322"};